import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import IndexPage from "./pages/IndexPage.js";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/">
          <IndexPage />
        </Route>
      </Switch>
    </Router>
  );
}

var mountNode = document.getElementById("react-app");
ReactDOM.render(<App />, mountNode);
